import React, { ComponentType, useContext, useEffect, useState } from 'react';
import { ErrorContext } from '../../lib/ErrorContext';
import Questions from '../../lib/Questions';
import type { FormQuestion } from '~/lib/Api.types';
import { QuestionComponentProps } from '~/lib/Questions/Questions.types';

type QuestionProps<QuestionValue = string> = {
    isReadOnly?: boolean;
    question: FormQuestion;
    className?: string;
    id: FormQuestion['id'];
    value: QuestionValue;
    setValue: (value: QuestionValue) => void;
};
const Question = ({
    question,
    value,
    setValue,
    className,
    id: questionId,
    isReadOnly = false,
}: QuestionProps) => {
    const [isChangedAfterError, setIsChangedAfterError] = useState(false);
    const { label, type, settings } = question;
    const id = questionId ? `${questionId}` : `q-${type}-${Math.random()}`;

    const { errors, errorsUpdatedAt } = useContext(ErrorContext);

    let errorMessage = '';
    if (id && errors && errors[id] && !isChangedAfterError) {
        errorMessage = errors[id];
    }

    useEffect(() => {
        if (errors && id && errors[id]) {
            setIsChangedAfterError(false);
        }
    }, [JSON.stringify(errors), errorsUpdatedAt?.toString()]);

    useEffect(() => {
        setIsChangedAfterError(true);
    }, [JSON.stringify(value)]);

    const questionSchema = Questions[type ?? ''];
    const QuestionComponent: ComponentType<QuestionComponentProps> =
        questionSchema.component;
    return (
        <div className={`${!!errorMessage && !questionSchema.componentHandlesErrors ? 'is-error' : ''} ${className}`}>
            <QuestionComponent
                isReadOnly={isReadOnly}
                label={label}
                value={value}
                setValue={setValue}
                settings={{ ...settings, isError: !!errorMessage }}
                id={id}
            />

            {!!errorMessage && !questionSchema.componentHandlesErrors && (
                <div className="text-sm text-red-600 ml-4 mt-1">
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default Question;
